import FormArea from "./formArea.vue";
export default FormArea;
export type FormAreaInstance = InstanceType<typeof FormArea>;

export const MOBILE_REG = "^1[3-9]\\d{9}$";
